import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import type { CashierConfig } from '@/models/cashier-settings/cashier-settings.model';

export default class GetCashierConfigRequest extends ApiResourceMethod<CashierConfig> {
  public perform(url: string): Promise<CashierConfig> {
    return this.performer.requestWithMapper(
      { url },
      (response: BaseResponse<CashierConfig>) => response.data,
    );
  }
}
